import { render, staticRenderFns } from "./ThemesEditorTabs.vue?vue&type=template&id=275dfddc"
import script from "./ThemesEditorTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorTabs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports